import { Pipe, PipeTransform } from '@angular/core';

import { DateHelpers } from '@lockton-apps/shared/util/helpers';

@Pipe({
  name: 'isoDifferenceInDaysToNow',
  standalone: true,
})
export class IsoDifferenceInDaysToNowPipe implements PipeTransform {
  transform(date: string): number {
    return DateHelpers.isoDifferenceInDaysToNow(date);
  }
}
